export const isAuthenticated = (state) => !!state.token
export const authStatus = (state) => state.status
export const userType = (state) => state.userType
